// extracted by mini-css-extract-plugin
export default {"img":"src-slices-HeroSlice-HeroSlice__img","container":"src-slices-HeroSlice-HeroSlice__container"};